var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.src)?_c('div',{staticClass:"download"},[(_vm.downloading)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_c('i',{staticClass:"fas fa-download",on:{"click":_vm.downloadFile}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }